import { useState, useEffect } from 'react';
import { SupportedMimeType } from '../enums';
import { IArtifact, IFile } from '../interfaces/artifact.interfaces';
import { getBlob } from '../services/artifact.service';

type BlobLoaderState = {
    loading: boolean;
    blob?: Blob;
    error?: boolean;
};

interface UseBlobLoaderProps {
    mailboxId: string;
    artifact: IArtifact;
    file: IFile;
    mimeType?: SupportedMimeType;
}

type UseBlobLoaderActions = BlobLoaderState;

/**
 * Load a blob from a mail
 */
export const useBlobLoader = ({
    mailboxId,
    artifact,
    file,
    mimeType = SupportedMimeType.TXT,
}: UseBlobLoaderProps): UseBlobLoaderActions => {
    const [state, setState] = useState<BlobLoaderState>({
        loading: true,
        blob: undefined,
        error: false,
    });

    useEffect(() => {
        let isCancelled = false;

        const loadBlobAsync = async (): Promise<void> => {
            try {
                const blob = await getBlob(mailboxId, artifact.messageId, artifact.id, file.id, mimeType);

                if (isCancelled) {
                    return;
                }

                setState({
                    blob,
                    loading: false,
                });
            } catch (e) {
                console.error(e);

                if (isCancelled) {
                    return;
                }

                setState({
                    loading: false,
                    error: true,
                });
            }
        };

        loadBlobAsync();

        return (): void => {
            isCancelled = true;
        };
    }, [artifact, mailboxId, mimeType, file]);

    return state;
};
